import Image from "next/image";
import { FC } from "react";
import { twMerge } from "tailwind-merge";

interface Props {
  minimized?: boolean;
}

const SubscriptionSnapp: FC<Props> = ({ minimized }) => {
  return (
    <div className="w-full gap-x-1 fds-md:gap-x-2 items-center flex ">
      <div className="relative h-6 w-6 md:h-9 md:w-9">
        <Image
          src="https://faradars.org/wp-content/uploads/2025/11/16/snappay.svg"
          alt="snap-pay"
          layout="fill"
        />
      </div>
      <p
        className={twMerge(
          "title-sm text-fds-secondary",
          minimized ? "md:title-md-demibold" : "md:title-md-medium"
        )}
      >
        امکان پرداخت در ۴ قسط
      </p>
    </div>
  );
};
export default SubscriptionSnapp;
